import Enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import packageHelper from "../../helper/packagehelper";
import uploadHelper from "../../helper/uploadHelper";
import i18n from "../../locales/i18n";

//#region transactionInputFunction
function TransactionSearchCriteria(input) {
  let transactionSearchCriteria = {
    searchText: input ? input.searchText : "",
    datetype: 0,
    fromDate: input ? input.fromDate : null,
    toDate: input ? input.toDate : null,
    fromNetAmount: null,
    toNetAmount: null,
    isShowDeleted: input ? input.isShowDeleted : false,
  };

  return transactionSearchCriteria;
}
function ImportTableView(input) {
  let ImportTableView = {
    tableStatus: input ? input.tableStatus : 0,
    tableSorting: input ? input.tableSorting : 0,
    importTableView: input ? input.importTableView : 0,
    pageNo: input ? input.pageNo : 1,
    pageSize: input ? input.pageSize : 10,
    searchText: input ? input.searchText : "",
    orderText: "id DESC",
  };

  return ImportTableView;
}
//#endregion

//#region transactionTableOutputFunction
function RecurringTableListModel(transactionList) {
  let transactionModel = [];
  if (transactionList !== null) {
    for (let count = 0; count < transactionList.length; count++) {
      let transactionItem = transactionList[count];
      let transaction = {
        id: transactionItem.id,
        number: transactionItem.number,
        contactId: transactionItem.contactId,
        transactionNetAmount: transactionItem.transactionNetAmount,
        isArchived: transactionItem.isArchived,
        periodType: transactionItem.periodType,
        everyXDay: transactionItem.everyXDay,
        day: transactionItem.day,
        week: transactionItem.week,
        date: transactionItem.date,
        month: transactionItem.month,
        status: transactionItem.status,
        createdTransactionAsStatus: transactionItem.createdTransactionAsStatus,
        recurringNextTime: transactionItem.recurringNextTime,
      };
      transactionModel.push(transaction);
    }
  }
  return transactionModel;
}
//#endregion

function ImportListToImportTableList(_importList) {
  let importList = [];
  _importList.forEach((importData, index) => {
    let importModel = {
      id: importData.id,
      uuid: importData.uuid,
      code: importData.code,
      approvedDate: importData.approvedDate ? importData.approvedDate.NewDateTimeUctToTimezone() : "",
      createdDateTime: importData.createdDateTime.NewDateTimeUctToTimezone(),
      approvedUserId: importData.approvedUserId,
      userId: importData.userId,
      userDisplayName: importData.userDisplayName,
      transactionType: importData.transactionType,
      financeType: importData.financeType,
      expenseType: importData.expenseType,
      importStatus: importData.importStatus,
      importType: importData.importType,
      transactionCount: importData.transactionCount,
      isDeleted: importData.isDeleted,
      importTransactionType: importData.importTransactionType,
    };
    importList.push(importModel);
  });
  return importList;
}
function ImportCountToImportTableCount(_importCount) {
  let model = {
    all: _importCount.all,
    quotation: _importCount.quotation,
    invoice: _importCount.invoice,
    receipt: _importCount.receipt,
    purchaseOrder: _importCount.purchaseOrder,
    purchaseInventory: _importCount.purchaseInventory,
    expense: _importCount.expense,
    voided: _importCount.voided,
    receiptFromInvoice: _importCount.receiptFromInvoice,
    receiptFromQuotation: _importCount.receiptFromQuotation,
    invoiceFromQuotation: _importCount.invoiceFromQuotation,
    journal: _importCount.journal,
  };
  return model;
}
function TransactionSummaryModel(transactionSummary) {
  let transactionSummaryModel = {
    netAmount: transactionSummary.netAmount,
    preVatTotal: transactionSummary.preVatTotal,
    remainPaymentNetAmount: transactionSummary.remainPaymentNetAmount,
    remainWhtPaymentNetAmount: transactionSummary.remainWhtPaymentNetAmount,
    subTotal: transactionSummary.subTotal,
    subTotalForCalculateWht: transactionSummary.subTotalForCalculateWht,
    vatExemptedTotal: transactionSummary.vatExemptedTotal,
    vatTotal: transactionSummary.vatTotal,
    whtTotal: transactionSummary.whtTotal,
    zeroVatTotal: transactionSummary.zeroVatTotal,
    sameProductVatType: transactionSummary.sameProductVatType,
  };
  return transactionSummaryModel;
}
function GetGroupListByContactTable(id, contactGroupList) {
  let contactGroupTableList = [];
  if (contactGroupList && contactGroupList.length > 0) {
    contactGroupList.forEach((contactGroupTable) => {
      if (contactGroupTable.contactId === id) {
        contactGroupTableList.push({
          name: contactGroupTable.groupName,
          contactGroupId: contactGroupTable.contactGroupId,
          color: contactGroupTable.color,
        });
      }
    });
    contactGroupTableList.sort((a, b) => {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
  return contactGroupTableList;
}
function whtTableListModel(WhtTableList) {
  let whtTableListModels = [];
  if (WhtTableList !== null) {
    for (let count = 0; count < WhtTableList.length; count++) {
      let whtTableItem = WhtTableList[count];
      let model = {
        whtId: whtTableItem.whtId,
        transactionId: whtTableItem.transactionId,
        transactionType: whtTableItem.transactionType,
        transactionNumber: whtTableItem.transactionNumber,
        whtNumber: whtTableItem.whtNumber,
        contactId: whtTableItem.contactId,
        contactFullName: whtTableItem.contactFullName,
        contactBranchCode: whtTableItem.contactBranchCode,
        contactTaxId: whtTableItem.contactTaxId,
        contactCode: whtTableItem.contactCode,
        subTotalForCalculateWht: whtTableItem.subTotalForCalculateWht,
        whtDate: whtTableItem.whtDate,
        whtTotal: whtTableItem.whtTotal,
        whtAmountType: whtTableItem.whtAmountType,
        isReceivedWht: whtTableItem.isReceivedWht,
        isDeleted: whtTableItem.isDeleted,
        whtCertificateId: whtTableItem.whtCertificateId,
      };
      whtTableListModels.push(model);
    }
  }
  return whtTableListModels;
}

//#region Invoice
function GetInvoiceTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    isAllFixAssetTemplateSearch: null,
    assetTemplateIdList: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    receivedTaxInvoiceNumber: null,
    receivedTaxInvoiceDate: null,
  };
}
function GetInvoiceTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    isAllFixAssetTemplateSearch: null,
    assetTemplateIdList: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    receivedTaxInvoiceNumber: null,
    receivedTaxInvoiceDate: null,
  };
}
function GetInvoiceTableRequest(input) {
  let data = GetInvoiceTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetInvoiceTableAdvanceSearchRequest(input) {
  let data = GetInvoiceTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetInvoiceTableVeryAdvanceSearchRequest(input) {
  let data = GetInvoiceTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}

function GetExpenseTableVeryAdvanceSearchRequest(input) {
  let data = GetInvoiceTableVeryAdvanceSearchRequest(input);
  data.receivedTaxInvoiceNumber = input.searchAdvance.receivedTaxInvoiceNumber;
  data.receivedTaxInvoiceDate = input.searchAdvance.receivedTaxInvoiceDate;
  return data;
}

function GetPurchaseAssetTableVeryAdvanceSearchRequest(input) {
  let data = GetExpenseTableVeryAdvanceSearchRequest(input);
  data.isAllFixAssetTemplateSearch = input.searchAdvance.isAllFixAssetTemplateSearch;
  data.assetTemplateIdList = input.searchAdvance.fixAssetTemplateIdList;
  return data;
}
function GetInvoiceTableCountRequest(input) {
  let data = GetInvoiceTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetInvoiceTableCountAdvanceSearchRequest(input) {
  let data = GetInvoiceTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetInvoiceTableCountVeryAdvanceSearchRequest(input) {
  let data = GetInvoiceTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetExpenseTableCountVeryAdvanceSearchRequest(input) {
  let data = GetInvoiceTableCountVeryAdvanceSearchRequest(input);
  data.receivedTaxInvoiceNumber = input.searchAdvance.receivedTaxInvoiceNumber;
  data.receivedTaxInvoiceDate = input.searchAdvance.receivedTaxInvoiceDate;
  return data;
}

function GetPurchaseAssetTableCountVeryAdvanceSearchRequest(input) {
  let data = GetExpenseTableCountVeryAdvanceSearchRequest(input);
  data.isAllFixAssetTemplateSearch = input.searchAdvance.isAllFixAssetTemplateSearch;
  data.assetTemplateIdList = input.searchAdvance.fixAssetTemplateIdList;
  return data;
}

function GetInvoiceTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        dueDate: tableItem.dueDate,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        status: tableItem.status,
        isCreatedTaxInvoice: tableItem.isCreatedTaxInvoice,
        vatTotal: tableItem.vatTotal,
        preVatTotal: tableItem.preVatTotal,
        taxStatus: tableItem.taxStatus,
        transactionItemType: tableItem.transactionItemType,
        taxInvoiceIssuedReceivedModelList: null,
        remainPayment: 0,
        referenceReceiptId: 0,
        receiptCreateStatus: 0,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
function GetLastestInvoiceId(invoiceNumberList) {
  if (invoiceNumberList && invoiceNumberList.length > 0) {
    return invoiceNumberList[invoiceNumberList.length - 1].invoiceId;
  }
  return 0;
}
//#endregion
//#region Quotation
function GetQuotationTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromActionDate: null,
    toActionDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    assetTemplateIdList: null,
    isAllFixAssetTemplateSearch: null,
  };
}
function GetQuotationTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromActionDate: null,
    toActionDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    assetTemplateIdList: null,
    isAllFixAssetTemplateSearch: null,
  };
}
function GetQuotationTableRequest(input) {
  let data = GetQuotationTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetQuotationTableAdvanceSearchRequest(input) {
  let data = GetQuotationTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromActionDate = input.searchAdvance.fromAcceptedDate;
  data.toActionDate = input.searchAdvance.toAcceptedDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetQuotationTableVeryAdvanceSearchRequest(input) {
  let data = GetQuotationTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetQuotationTableCountRequest(input) {
  let data = GetQuotationTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetQuotationTableCountAdvanceSearchRequest(input) {
  let data = GetQuotationTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromActionDate = input.searchAdvance.fromAcceptedDate;
  data.toActionDate = input.searchAdvance.toAcceptedDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetQuotationTableCountVeryAdvanceSearchRequest(input) {
  let data = GetQuotationTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetQuotationTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        dueDate: tableItem.dueDate,
        actionDate: tableItem.actionDate,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        status: tableItem.status,
        vatTotal: tableItem.vatTotal,
        preVatTotal: tableItem.preVatTotal,
        taxStatus: tableItem.taxStatus,
        transactionItemType: tableItem.transactionItemType,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
function GetQuotationReferenceInvoiceListOutput(_quotationReferenceInvoiceList) {
  let quotationReferenceInvoiceList = [];
  if (_quotationReferenceInvoiceList && _quotationReferenceInvoiceList.length > 0) {
    for (let _quotationReferenceInvoice of _quotationReferenceInvoiceList) {
      quotationReferenceInvoiceList.push({
        quotationId: _quotationReferenceInvoice.quotationId,
        invoiceNumberList: _quotationReferenceInvoice.invoiceNumberList,
        lastestInvoiceId: GetLastestInvoiceId(_quotationReferenceInvoice.invoiceNumberList),
      });
    }
  }
  return quotationReferenceInvoiceList;
}
//#endregion
//#region PurchaseOrder
function GetPurchaseOrderTableAdvanceSearchRequest(input) {
  let data = GetQuotationTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}

function GetPurchaseOrderTableVeryAdvanceSearchRequest(input) {
  let data = GetPurchaseOrderTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}

function GetPurchaseOrderTableCountAdvanceSearchRequest(input) {
  let data = GetQuotationTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}

function GetPurchaseOrderTableCountVeryAdvanceSearchRequest(input) {
  let data = GetPurchaseOrderTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
//#endregion

//#region PurchaseOrderAsset
function GetPurchaseOrderAssetTableVeryAdvanceSearchRequest(input) {
  let data = GetPurchaseOrderTableVeryAdvanceSearchRequest(input);
  data.isAllFixAssetTemplateSearch = input.searchAdvance.isAllFixAssetTemplateSearch;
  data.assetTemplateIdList = input.searchAdvance.fixAssetTemplateIdList;
  return data;
}

function GetPurchaseOrderAssetTableCountVeryAdvanceSearchRequest(input) {
  let data = GetPurchaseOrderTableCountVeryAdvanceSearchRequest(input);
  data.isAllFixAssetTemplateSearch = input.searchAdvance.isAllFixAssetTemplateSearch;
  data.assetTemplateIdList = input.searchAdvance.fixAssetTemplateIdList;
  return data;
}
//#endregion

//#region Receipt
function GetReceiptTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
  };
}
function GetReceiptTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
  };
}
function GetReceiptTableRequest(input) {
  let data = GetReceiptTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetReceiptTableAdvanceSearchRequest(input) {
  let data = GetReceiptTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetReceiptTableVeryAdvanceSearchRequest(input) {
  let data = GetReceiptTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetReceiptTableCountRequest(input) {
  let data = GetReceiptTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetReceiptTableCountAdvanceSearchRequest(input) {
  let data = GetReceiptTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetReceiptTableCountVeryAdvanceSearchRequest(input) {
  let data = GetReceiptTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetReceiptTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        status: tableItem.status,
        isCreatedTaxInvoice: tableItem.isCreatedTaxInvoice,
        vatTotal: tableItem.vatTotal,
        preVatTotal: tableItem.preVatTotal,
        taxStatus: tableItem.taxStatus,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
//#endregion
//#region TaxInvoice
function GetTaxInvoiceTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    filterETaxInvoiceType: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
  };
}
function GetTaxInvoiceTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    filterETaxInvoiceType: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
  };
}
function GetTaxInvoiceTableRequest(input) {
  let data = GetTaxInvoiceTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  data.filterETaxInvoiceType = input.filterETaxInvoiceType;
  return data;
}
function GetTaxInvoiceTableAdvanceSearchRequest(input) {
  let data = GetTaxInvoiceTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetTaxInvoiceTableVeryAdvanceSearchRequest(input) {
  let data = GetTaxInvoiceTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetTaxInvoiceTableCountRequest(input) {
  let data = GetTaxInvoiceTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  data.filterETaxInvoiceType = input.filterETaxInvoiceType;
  return data;
}
function GetTaxInvoiceTableCountAdvanceSearchRequest(input) {
  let data = GetTaxInvoiceTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetTaxInvoiceTableCountVeryAdvanceSearchRequest(input) {
  let data = GetTaxInvoiceTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetTaxInvoiceTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    transactionList = tableList.map((tableItem) => ({
      id: tableItem.isAutoGenerated ? tableItem.referenceTransactionId : tableItem.id,
      transactionType: tableItem.isAutoGenerated
        ? tableItem.referenceTransactionType
        : Enums.TransactionType.TaxInvoice,
      number: tableItem.number,
      date: tableItem.date,
      contactId: tableItem.contactId,
      transactionVat:
        (tableItem.referenceTransactionType == Enums.TransactionType.CreditNote ? -1 : 1) * tableItem.vatTotal,
      transactionNetAmount:
        (tableItem.referenceTransactionType == Enums.TransactionType.CreditNote ? -1 : 1) * tableItem.netAmount,
      status: tableItem.status,
      taxInvoiceId: tableItem.id,
      expenseTypeId: tableItem.transactionItemType,
      eTaxInvoiceId: tableItem.eTaxInvoiceId,
    }));
  }
  return transactionList;
}
//#endregion
//#region CreditNote
function GetCreditNoteTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
  };
}
function GetCreditNoteTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    receivedTaxInvoiceNumber: null,
    receivedTaxInvoiceDate: null,
  };
}
function GetCreditNoteTableRequest(input) {
  let data = GetCreditNoteTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetCreditNoteTableAdvanceSearchRequest(input) {
  let data = GetCreditNoteTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetCreditNoteTableVeryAdvanceSearchRequest(input) {
  let data = GetCreditNoteTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetReceivedCreditNoteTableVeryAdvanceSearchRequest(input) {
  let data = GetCreditNoteTableVeryAdvanceSearchRequest(input);
  data.receivedTaxInvoiceNumber = input.searchAdvance.receivedTaxInvoiceNumber;
  data.receivedTaxInvoiceDate = input.searchAdvance.receivedTaxInvoiceDate;
  return data;
}
function GetCreditNoteTableCountRequest(input) {
  let data = GetCreditNoteTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetCreditNoteTableCountAdvanceSearchRequest(input) {
  let data = GetCreditNoteTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetCreditNoteTableCountVeryAdvanceSearchRequest(input) {
  let data = GetCreditNoteTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetReceivedCreditNoteTableCountVeryAdvanceSearchRequest(input) {
  let data = GetCreditNoteTableCountVeryAdvanceSearchRequest(input);
  data.receivedTaxInvoiceNumber = input.searchAdvance.receivedTaxInvoiceNumber;
  data.receivedTaxInvoiceDate = input.searchAdvance.receivedTaxInvoiceDate;
  return data;
}
function GetCreditNoteTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        status: tableItem.status,
        isCreatedTaxInvoice: tableItem.isCreatedTaxInvoice,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
//#endregion
//#region DebitNote
function GetDebitNoteTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    receivedTaxInvoiceNumber: null,
    receivedTaxInvoiceDate: null,
  };
}
function GetDebitNoteTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
    receivedTaxInvoiceNumber: null,
    receivedTaxInvoiceDate: null,
  };
}
function GetDebitNoteTableRequest(input) {
  let data = GetDebitNoteTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetDebitNoteTableAdvanceSearchRequest(input) {
  let data = GetDebitNoteTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetDebitNoteTableVeryAdvanceSearchRequest(input) {
  let data = GetDebitNoteTableAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetReceivedDebitNoteTableVeryAdvanceSearchRequest(input) {
  let data = GetDebitNoteTableVeryAdvanceSearchRequest(input);
  data.receivedTaxInvoiceNumber = input.searchAdvance.receivedTaxInvoiceNumber;
  data.receivedTaxInvoiceDate = input.searchAdvance.receivedTaxInvoiceDate;
  return data;
}
function GetDebitNoteTableCountRequest(input) {
  let data = GetDebitNoteTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetDebitNoteTableCountAdvanceSearchRequest(input) {
  let data = GetDebitNoteTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetDebitNoteTableCountVeryAdvanceSearchRequest(input) {
  let data = GetDebitNoteTableCountAdvanceSearchRequest(input);
  data.searchTextTransactionItemDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.productTemplateIdList = input.searchAdvance.productTemplateIdList;
  data.isAllProductTemplateSearch = input.searchAdvance.isAllProductTemplateSearch;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  return data;
}
function GetReceivedDebitNoteTableCountVeryAdvanceSearchRequest(input) {
  let data = GetDebitNoteTableCountVeryAdvanceSearchRequest(input);
  data.receivedTaxInvoiceNumber = input.searchAdvance.receivedTaxInvoiceNumber;
  data.receivedTaxInvoiceDate = input.searchAdvance.receivedTaxInvoiceDate;
  return data;
}
function GetDebitNoteTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        dueDate: tableItem.dueDate,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        status: tableItem.status,
        isCreatedTaxInvoice: tableItem.isCreatedTaxInvoice,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
//#endregion
//#region BillingNote
function GetBillingNoteTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    transactionTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
  };
}
function GetBillingNoteTableCountRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromPaymentDate: null,
    toPaymentDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
  };
}
function GetBillingNoteTableRequest(input) {
  let data = GetBillingNoteTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.transactionTableView = input.transactionTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetBillingNoteTableAdvanceSearchRequest(input) {
  let data = GetBillingNoteTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetBillingNoteTableVeryAdvanceSearchRequest(input) {
  let data = GetBillingNoteTableAdvanceSearchRequest(input);
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;

  return data;
}
function GetBillingNoteTableCountRequest(input) {
  let data = GetBillingNoteTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetBillingNoteTableCountAdvanceSearchRequest(input) {
  let data = GetBillingNoteTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.fromDueDate = input.searchAdvance.fromDueDate;
  data.toDueDate = input.searchAdvance.toDueDate;
  data.fromPaymentDate = input.searchAdvance.fromPaymentDate;
  data.toPaymentDate = input.searchAdvance.toPaymentDate;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetBillingNoteTableCountVeryAdvanceSearchRequest(input) {
  let data = GetBillingNoteTableCountAdvanceSearchRequest(input);
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  return data;
}
function GetBillingNoteTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        dueDate: tableItem.dueDate,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        transactionTableStatus: ConverBillingNoteStatusToTransactionTableStatus(tableItem.status),
        referenceReceiptId: 0,
        receiptCreateStatus: 0,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
function ConverBillingNoteStatusToTransactionTableStatus(billingNoteStatus) {
  switch (billingNoteStatus) {
    case Enums.BillingNoteStatus.Draft:
      return Enums.TransactionTableViewStatusType.Draft;
    case Enums.BillingNoteStatus.AwaitApproval:
      return Enums.TransactionTableViewStatusType.AwaitApproval;
    case Enums.BillingNoteStatus.Outstanding:
      return Enums.TransactionTableViewStatusType.WaitingPayment;
    case Enums.BillingNoteStatus.Overdue:
      return Enums.TransactionTableViewStatusType.OverDue;
    case Enums.BillingNoteStatus.PaidOrAwaitReceipt:
      return Enums.TransactionTableViewStatusType.Paid;
    case Enums.BillingNoteStatus.Voided:
      return Enums.TransactionTableViewStatusType.Voided;
  }
  return Enums.TransactionTableViewStatusType.All;
}
//#endregion
//#region product
//#region account
function GetJournalTableRequestModel() {
  return {
    tableStatus: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    tableSorting: null,
    journalTableView: null,
    pageNo: null,
    pageSize: null,
    isUseMainDatabase: null,
    journalTableType: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromActionDate: null,
    toActionDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
  };
}
function GetJournalTableCountRequestModel() {
  return {
    tableStatus: null,
    journalTableType: null,
    fromDate: null,
    toDate: null,
    searchText: null,
    isUseMainDatabase: null,
    contactId: null,
    searchNumber: null,
    searchReference: null,
    fromDueDate: null,
    toDueDate: null,
    fromActionDate: null,
    toActionDate: null,
    fromNetAmount: null,
    toNetAmount: null,
    searchTextTransactionItemDescription: null,
    productTemplateIdList: null,
    isAllProductTemplateSearch: null,
    tagIdList: null,
    isAllTagSearch: null,
    createdUserId: null,
    approvedUserId: null,
    allocationIdList: null,
    allocationItemIdList: null,
    isNotHaveAllocation: null,
    isNotHaveAnyAllocation: null,
  };
}
function GetJournalTableRequest(input) {
  let data = GetJournalTableRequestModel();
  data.tableStatus = input.tableStatus;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.tableSorting = input.tableSorting;
  data.journalTableView = input.journalTableView;
  data.pageNo = input.pageNo;
  data.pageSize = input.pageSize;
  data.isUseMainDatabase = input.isUseMainDatabase;
  data.journalTableType = input.journalTableType;
  return data;
}
function GetJournalTableAdvanceSearchRequest(input) {
  let data = GetJournalTableRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.searchDescription = input.searchAdvance.searchTextTransactionDescription;
  return data;
}
function GetJournalTableVeryAdvanceSearchRequest(input) {
  let data = GetJournalTableAdvanceSearchRequest(input);
  data.journalAccountDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.reviewedUserId = input.searchAdvance.reviewedUserId;
  data.accountId = input.searchAdvance.accountId;
  data.journalAccountReferenceId = input.searchAdvance.accountReferenceId;
  data.journalAccountReferenceTypeId = input.searchAdvance.accountReferenceType;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetJournalTableCountRequest(input) {
  let data = GetJournalTableCountRequestModel();
  data.tableStatus = input.tableStatus;
  data.journalTableType = input.journalTableType;
  data.fromDate = input.fromDate;
  data.toDate = input.toDate;
  data.searchText = input.searchText;
  data.isUseMainDatabase = input.isUseMainDatabase;
  return data;
}
function GetJournalTableCountAdvanceSearchRequest(input) {
  let data = GetJournalTableCountRequest(input);
  data.contactId = input.searchAdvance.contactId;
  data.searchNumber = input.searchAdvance.searchTextTransactionNumber;
  data.searchReference = input.searchAdvance.searchTextReference;
  data.searchDescription = input.searchAdvance.searchTextTransactionDescription;
  return data;
}
function GetJournalTableCountVeryAdvanceSearchRequest(input) {
  let data = GetJournalTableCountAdvanceSearchRequest(input);
  data.journalAccountDescription = input.searchAdvance.searchTextTransactionItemDescription;
  data.tagIdList = input.searchAdvance.tagIdList;
  data.isAllTagSearch = input.searchAdvance.isAllTagSearch;
  data.createdUserId = input.searchAdvance.createdUserId;
  data.approvedUserId = input.searchAdvance.approvedUserId;
  data.reviewedUserId = input.searchAdvance.reviewedUserId;
  data.accountId = input.searchAdvance.accountId;
  data.journalAccountReferenceId = input.searchAdvance.accountReferenceId;
  data.journalAccountReferenceTypeId = input.searchAdvance.accountReferenceType;
  data.allocationIdList = input.searchAdvance.allocationIdList;
  data.allocationItemIdList = input.searchAdvance.allocationItemIdList;
  data.isNotHaveAllocation = input.searchAdvance.isNotHaveAllocation;
  data.isNotHaveAnyAllocation = input.searchAdvance.isNotHaveAnyAllocation;
  data.fromNetAmount = input.searchAdvance.fromNetAmount;
  data.toNetAmount = input.searchAdvance.toNetAmount;
  return data;
}
function GetJournalTableOutput(tableList) {
  let transactionList = [];
  if (tableList && tableList.length > 0) {
    for (let tableItem of tableList) {
      let transaction = {
        id: tableItem.id,
        uuId: tableItem.uuId,
        date: tableItem.date,
        dueDate: tableItem.dueDate,
        actionDate: tableItem.actionDate,
        number: tableItem.number,
        contactId: tableItem.contactId,
        transactionNetAmount: tableItem.netAmount,
        status: tableItem.status,
        taxStatus: tableItem.taxStatus,
        transactionItemType: tableItem.transactionItemType,
        type: tableItem.type,
        totalCredit: tableItem.totalCredit,
        totalDebit: tableItem.totalDebit,
        validationStatus: tableItem.validationStatus,
        isDeleted: tableItem.isDeleted,
        description: tableItem.description,
      };
      transactionList.push(transaction);
    }
  }
  return transactionList;
}
function GetStockActivityTableRequest(_input) {
  let input = {
    productTemplateId: _input.productId,
    fromDate: _input.fromDate,
    toDate: _input.toDate,
    searchText: _input.searchText,
    pageNo: _input.pageNo,
    pageSize: _input.pageSize,
    isGetBeginingBalance: _input.isGetBeginingBalance,
    isUseMainDatabase: _input.isUseMainDatabase,
  };
  return input;
}

function GetStockActivityTableCountRequest(_input) {
  let input = {
    productTemplateId: _input.productId,
    fromDate: _input.fromDate,
    toDate: _input.toDate,
    searchText: _input.searchText,
    isUseMainDatabase: _input.isUseMainDatabase,
  };
  return input;
}
function GetStockActivityTableOutput(tableList, isShowRemain) {
  let stockActivityTableList = [];
  if (tableList && tableList.length > 0) {
    tableList.forEach((table) => {
      stockActivityTableList.push({
        amount: table.amount,
        contactId: table.contactId,
        date: table.date,
        financeType: table.financeType,
        id: table.id,
        isAdjust: table.isAdjust,
        price: table.price,
        stockAdjustmentType: table.stockAdjustmentType,
        transactionId: table.transactionId,
        transactionNumber: table.transactionNumber,
        transactionType: table.transactionType,
        remain: table.remain,
        total: table.total,
        isBeginingBalanceFromTable: table.isBeginingBalanceFromTable,
        stockMovementTableType: table.stockMovementTableType,
        isShowRemain: isShowRemain,
      });
    });
  }
  return stockActivityTableList;
}
function GetLotTableOutput(lot) {
  if (lot && lot.sequenceNumber > 0) {
    let total = 0;
    const tableList = [];
    if (lot.lotMovementTableList && lot.lotMovementTableList.length > 0) {
      for (const lotMovement of lot.lotMovementTableList) {
        const number = lotMovement.isAdjustAmount ? lotMovement.journalNumber : lotMovement.transactionNumber;
        total++;
        tableList.push({
          sequenceNumber: lotMovement.sequenceNumber,
          type: lotMovement.type,
          stockActivityId: lotMovement.stockActivityId,
          date: lotMovement.date,
          amount: lotMovement.amount,
          cost: lotMovement.cost,
          totalCost: lotMovement.totalCost,
          remainAmount: lotMovement.remainAmount,
          remainCost: lotMovement.remainCost,
          contactId: lotMovement.contactId,
          contactName: "",
          transactionId: lotMovement.transactionId,
          transactionType: lotMovement.transactionType,
          financeType: lotMovement.financeType,
          transactionNumber: lotMovement.transactionNumber,
          journalId: lotMovement.journalId,
          journalNumber: lotMovement.journalNumber,
          isAdjustAmount: lotMovement.isAdjustAmount,
          number: number,
        });
      }
    }
    return {
      sequenceNumber: lot.sequenceNumber,
      date: lot.date,
      number: lot.number,
      costPerUnit: lot.costPerUnit,
      remainAmount: lot.remainAmount,
      remainCost: lot.remainCost,
      total: total,
      tableList: tableList,
    };
  }
  return null;
}
//#endregion
export default {
  //#region Finance
  GetImportTableInput(input) {
    return {
      merchantId: userInfo.MerchantId(),
      importTableView: ImportTableView(input),
      isUseMainDatabase: input.isMain,
    };
  },
  GetImportTableOutput(_importTableList) {
    let importData;
    if (_importTableList !== null) {
      importData = {
        importList: ImportListToImportTableList(_importTableList.importList),
        statusCount: ImportCountToImportTableCount(_importTableList.statusCount),
      };
    }
    return importData;
  },

  //#endregion
  //#region Finance
  ConvertToPaymentTransactionTable(_paymentTransactionTable) {
    return _paymentTransactionTable;
  },
  ConvertToChequeAbleToReceiveTable(_chequeTableList) {
    return _chequeTableList;
  },
  ConvertToChequeWaitingReceiveTable(_chequeTableList) {
    return _chequeTableList;
  },
  ConvertToReceivedChequeTable(_chequeTableList) {
    return _chequeTableList;
  },
  ConvertToChequeCount(_chequeCount) {
    return _chequeCount;
  },
  //#endregion
  //#region Contact
  ConvertToContactGroupList(_contactGroupList) {
    let contactTableGroupCountList = [];
    if (_contactGroupList && _contactGroupList.length > 0) {
      _contactGroupList.forEach((contactGroupItem) => {
        contactTableGroupCountList.push({
          contactGroupId: contactGroupItem.contactGroupId,
          contactGroupName: contactGroupItem.contactGroupName,
          contactGroupUUID: contactGroupItem.contactGroupUUID,
          contactGroupColor: contactGroupItem.contactGroupColor,
          contactGroupDescription: contactGroupItem.contactGroupDescription,
        });
      });
    }
    return contactTableGroupCountList;
  },
  ConvertToContactTable(_contactTable) {
    let contactTableList = [];
    let contactTableCount = _contactTable.contactTableCount ? _contactTable.contactTableCount : 0;
    if (_contactTable.contactTableList && _contactTable.contactTableList.length > 0) {
      _contactTable.contactTableList.forEach((contactTable) => {
        contactTableList.push({
          id: contactTable.id,
          uuid: contactTable.uuid,
          merchantType: contactTable.merchantType,
          contactType: contactTable.contactType,
          name: contactTable.name,
          email: contactTable.email,
          accountPayable: contactTable.accountPayable,
          accountReceivable: contactTable.accountReceivable,
          taxId: contactTable.taxId,
          branchCode: contactTable.branchCode,
          postCode: contactTable.postCode,
          country: contactTable.country,
          province: contactTable.province,
          district: contactTable.district,
          subDistrict: contactTable.subDistrict,
          address: contactTable.address,
          code: contactTable.code,
          logoUrl: contactTable.logoUrl,
          groupList: GetGroupListByContactTable(contactTable.id, _contactTable.groupList),
        });
      });
    }
    return { contactTableList: contactTableList, contactTableCount: contactTableCount };
  },

  //#endregion
  //#region Product
  ConvertToProductTableCount(_productTableCount) {
    return {
      total: _productTableCount.total,
      productTotal: _productTableCount.productTotal,
      serviceTotal: _productTableCount.serviceTotal,
    };
  },
  ConvertToProductTable(_productTable) {
    let productTableList = [];
    if (_productTable.productTableList && _productTable.productTableList.length > 0) {
      _productTable.productTableList.forEach((productTable) => {
        productTableList.push({
          id: productTable.id,
          uuid: productTable.uuid,
          code: productTable.code,
          name: productTable.name,
          description: productTable.description,
          type: productTable.type,
          purchaseAvgPrice: productTable.purchaseAvgPrice,
          sellAvgPrice: productTable.sellAvgPrice,
          remainAmount: productTable.remainAmount,
          totalPurchasePrice: productTable.totalPurchasePrice,
          totalSellPrice: productTable.totalSellPrice,
          unitId: productTable.unit.id,
          unitType: productTable.unit.unitType,
          nameTh: productTable.unit.nameTh,
          nameEn: productTable.unit.nameEn,
          unitCode: productTable.unit.unitCode,
        });
      });
    }

    return productTableList;
  },
  ConvertToUnitTable(_unitTable) {
    let unitTable = {
      totalUnit: 0,
      unitList: [],
    };

    if (_unitTable.unitList.length > 0) {
      unitTable.totalUnit = _unitTable.totalUnit;
      _unitTable.unitList.forEach((unitItem) => {
        let unitModel = {
          id: unitItem.id,
          unitCode: unitItem.unitCode,
          unitType: unitItem.unitType,
          name: unitItem.name,
          nameTh: unitItem.nameTh,
          nameEng: unitItem.nameEng,
          isMain: unitItem.isMain,
          isDeleted: unitItem.isDeleted,
        };
        unitTable.unitList.push(unitModel);
      });
    }

    return unitTable;
  },
  ConvertToNewProductTable(_table) {
    let newProductTableList = [];
    if (_table.productTableList && _table.productTableList.length > 0) {
      _table.productTableList.forEach((table) => {
        newProductTableList.push({
          id: table.id,
          code: table.code,
          name: table.name,
          seletedProductUrl: table.seletedProductUrl,
          remainStockAmount: table.remainStockAmount,
          sellPrice: table.sellPrice,
          unit: table.unit,
        });
      });
    }
    return { tableList: newProductTableList, transactionCount: _table.transactionCount };
  },
  //#endregion
  //#region account
  GetJournalTableOutput(_journalTable) {
    let journalTableList = [];
    if (_journalTable.journalTableList.length > 0) {
      _journalTable.journalTableList.forEach((journal) => {
        journalTableList.push({
          id: journal.id,
          number: journal.number,
          date: journal.date,
          totalDebit: journal.totalDebit,
          totalCredit: journal.totalCredit,
          description: journal.description,
          type: journal.type,
          status: journal.status,
          isDeleted: journal.isDeleted,
          validationStatus: journal.validationStatus,
        });
      });
    }
    return journalTableList;
  },
  GetJournalTableCountOutput(_journalCountTable) {
    let journalTableCount = {};
    if (_journalCountTable !== null) {
      journalTableCount = {
        all: _journalCountTable.all,
        awaitRecord: _journalCountTable.awaitRecord,
        draft: _journalCountTable.draft,
        awaitApprove: _journalCountTable.awaitApprove,
        purchase: _journalCountTable.purchase,
        sales: _journalCountTable.sales,
        payment: _journalCountTable.payment,
        receive: _journalCountTable.receive,
        general: _journalCountTable.general,
        voided: _journalCountTable.voided,
        shouldBeCheck: _journalCountTable.shouldBeCheck,
      };
    }
    return journalTableCount;
  },
  //#endregion
  //#region UploadDocument
  GetUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      searchText: _input.searchText,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      tableStatus: _input.tableStatus,
      uploadDocumentTableView: _input.uploadDocumentTableView,
      tableSorting: _input.tableSorting,
      sortUploadDocumentTypeIdList: _input.sortUploadDocumentTypeIdList,
      sortUploadDocumentTransactionItemTypeIdList: _input.sortUploadDocumentTransactionItemTypeIdList,
      sortFileDocumentTypeIdList: _input.sortFileDocumentTypeIdList,
    };
  },
  async GetUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      let fileSize;
      let fileSizeMegaByte;
      for (let transaction of _transactionList) {
        fileSize = await uploadHelper.GetFileSizeFromUrl(transaction.fileFullUrl);
        fileSizeMegaByte = fileSize / (1024 * 1024);

        transactionList.push({
          fileName: transaction.fileName,
          fileType: transaction.fileType,
          fileUrl: transaction.fileUrl,
          fileFullUrl: transaction.fileFullUrl,
          fileSize: fileSizeMegaByte.ToAccountingRoundUp(2),
          id: transaction.id,
          uploadDocumentReferenceId: transaction.uploadDocumentReferenceId,
          uploadDate: transaction.uploadDate ? transaction.uploadDate.NewDateTimeUctToTimezone() : "",
          uploadDocumentReferenceNumber: transaction.uploadDocumentReferenceNumber,
          uploadDocumentReferenceType: transaction.uploadDocumentReferenceType,
          uploadDocumentReferenceTransactionItemType: transaction.uploadDocumentReferenceTransactionItemType,
          uploadDocumentTypeId: transaction.uploadDocumentTypeId,
          userId: transaction.userId,
          uploadDocumentOCRMongoId: transaction.uploadDocumentOCRMongoId,
          uploadDocumentStatusType: transaction.uploadDocumentStatusType,
          fileDocumentType: transaction.fileDocumentType,
          contactId: transaction.uploadDocumentReferenceContactId,
          uploadDocumentReferenceIssueDate: transaction.uploadDocumentReferenceIssueDate,
          disabled: transaction.uploadDocumentReferenceType > 0,
        });
      }
    }
    return transactionList;
  },
  GetInvoiceForReferenceUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      contactId: _input.contactId,
      financeType: _input.financeType,
      transactionItemType: _input.expenseType,
      isDraftOnly: _input.isDraftOnly,
    };
  },
  GetQuotationForReferenceUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      contactId: _input.contactId,
      financeType: _input.financeType,
      isDraftOnly: _input.isDraftOnly,
    };
  },
  GetReceiptForReferenceUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      contactId: _input.contactId,
      financeType: _input.financeType,
      isDraftOnly: _input.isDraftOnly,
    };
  },
  GetWhtForReferenceUploadDocumentTableInput(_input) {
    return {
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      pageNo: _input.pageNo,
      pageSize: _input.pageSize,
      contactId: _input.contactId,
    };
  },
  GetRecurringTableInput(_input) {
    return {
      merchantId: userInfo.MerchantId(),
      tableSearchCriteria: {
        transactionType: _input.transactionTypeId,
        financeType: _input.financeTypeId,
        expenseType: _input.expenseTypeId,
        tableSorting: _input ? _input.tableSorting : 0,
        transactionTableView: _input ? _input.tableSorting : Enums.RecurringTableView.Id,
        pageNo: _input ? _input.pageNo : 1,
        pageSize: _input ? _input.pageSize : 10,
        searchText: _input.searchText,
      },
      isUseMainDatabase: false,
    };
  },
  GetInvoiceForReferenceUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          id: transaction.transactionId,
          number: transaction.number,
          netAmount: transaction.netAmount,
          date: transaction.date,
        });
      }
    }
    return transactionList;
  },
  GetQuotationForReferenceUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          id: transaction.transactionId,
          number: transaction.number,
          netAmount: transaction.netAmount,
          date: transaction.date,
        });
      }
    }
    return transactionList;
  },
  GetReceiptForReferenceUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          id: transaction.transactionId,
          number: transaction.number,
          netAmount: transaction.netAmount,
          date: transaction.date,
        });
      }
    }
    return transactionList;
  },
  GetWhtForReferenceUploadDocumentTableOutput(_transactionList) {
    let transactionList = [];
    if (_transactionList && _transactionList.length > 0) {
      for (let transaction of _transactionList) {
        transactionList.push({
          id: transaction.transactionId,
          number: transaction.number,
          netAmount: transaction.netAmount,
          date: transaction.date,
        });
      }
    }
    return transactionList;
  },
  //#endregion
  //#region  Recurring
  GetRecurringTableOutput(_transactionTableList) {
    let invoice;
    if (_transactionTableList !== null) {
      invoice = {
        transactionList: RecurringTableListModel(_transactionTableList.transactionList),
        transactionCount: _transactionTableList.transactionCount,
      };
    }
    return invoice;
  },
  //#endregion

  GetWhtTableList(_input) {
    return {
      merchantId: userInfo.MerchantId(),
      isUseMainDatabase: _input.isUseMainDatabase,
      tableSearchCriteria: {
        tableStatus: _input ? _input.tableStatus : 0,
        paymentInOutFlowType: _input.paymentInOutFlowType ? _input.paymentInOutFlowType : 1,
        language: i18n.locale,
        sortingType: _input ? _input.sortingType : 0,
        sortBy: _input ? _input.sortBy : 1,
        searchText: _input.searchText,
        pageNumber: _input ? _input.pageNo : 1,
        pageSize: _input ? _input.pageSize : 10,
        fromDate: _input.advanceSearch.fromDate,
        toDate: _input.advanceSearch.toDate,
        filterReceivedWht: _input ? _input.filterReceivedWht : 0,
        isUseMainDatabase: _input.isUseMainDatabase,
      },
    };
  },
  GetWhtTableOutput(_whtTableList) {
    let wht = {};
    if (_whtTableList !== null) {
      wht = {
        transactionList: whtTableListModel(_whtTableList.whtTableList),
        transactionCount: _whtTableList.itemCount,
      };
    }
    return wht;
  },
  GetUserTableOutput(input) {
    return {
      isHaveSupportUser: input.isHaveSupportUser,
      userTableDetails: input.userTableDetails ? input.userTableDetails : [],
      allUserCount: input.alluserCount,
      lastestUpdateDatetime: input.lastestUpdateDatetime,
    };
  },
  GetAllocationTable(_table) {
    let table = {
      allocationTable: [],
      allcationCount: 0,
    };
    if (_table && _table.tableList !== null && _table.tableList.length > 0) {
      _table.tableList.forEach((element) => {
        table.allocationTable.push({
          id: element.id,
          number: element.number,
          name: element.name,
          allocationDocumentFinanceType: element.allocationDocumentFinanceType,
          isArchived: element.isArchived,
          allocationItemCount: element.allocationItemCount,
        });
      });
      table.allcationCount = _table.tableCount > 0 ? _table.tableCount : 0;
    }
    return table;
  },
  ConvertToUnpaidInvoiceList(_invoiceList) {
    let invoiceList = [];
    if (_invoiceList && _invoiceList.length > 0) {
      _invoiceList.forEach((element) => {
        invoiceList.push({
          id: element.id,
          contactId: element.contactId,
          dueDate: element.dueDate,
          issueDate: element.issueDate,
          invoiceNumber: element.invoiceNumber,
          isCreatedTaxInvoice: element.isCreatedTaxInvoice,
          transactionSummaryModel: TransactionSummaryModel(element.transactionSummaryModel),
        });
      });
    }
    return invoiceList;
  },
  ConvertToSubscriptionHistoryTable(_subscriptionHistoryTable) {
    let subscriptionHistoryTableDetail = [];
    if (
      _subscriptionHistoryTable.subscriptionHistoryRowModelList &&
      _subscriptionHistoryTable.subscriptionHistoryRowModelList.length > 0
    ) {
      _subscriptionHistoryTable.subscriptionHistoryRowModelList.forEach((subscriptionHistoryTable) => {
        subscriptionHistoryTableDetail.push({
          createDateTime: subscriptionHistoryTable.createDateTime,
          displayName: subscriptionHistoryTable.displayName,
          isCancelled: subscriptionHistoryTable.isCancelled,
          referenceMerchantId: subscriptionHistoryTable.referenceMerchantId,
          referenceMerchantName: subscriptionHistoryTable.referenceMerchantName,
          netAmount: subscriptionHistoryTable.netAmount,
          paymentGatewayType: subscriptionHistoryTable.paymentGatewayType,
          statusDetail: packageHelper.GetPaymentStatusDetail(subscriptionHistoryTable),
          paymentStatus: subscriptionHistoryTable.paymentStatus,
          peakPackage: subscriptionHistoryTable.peakPackage,
          peakPaymentConnectRefId: subscriptionHistoryTable.peakPaymentConnectRefId,
          peakPaymentConnectV2Id: subscriptionHistoryTable.peakPaymentConnectV2Id,
          peakpaymentConnectv2SwapId: subscriptionHistoryTable.peakpaymentConnectv2SwapId,
          puunMerchantId: subscriptionHistoryTable.puunMerchantId,
          puunReceiptId: subscriptionHistoryTable.puunReceiptId,
          receiptNumber: subscriptionHistoryTable.receiptNumber,
          status: subscriptionHistoryTable.status,
          updatedPeakerId: subscriptionHistoryTable.updatedPeakerId,
          receiptDate: subscriptionHistoryTable.receiptDate,
          isHaveWHT: subscriptionHistoryTable.isHaveWHT,
          subscriptionHistoryActionType: subscriptionHistoryTable.subscriptionHistoryActionType,
          campaignDescription: subscriptionHistoryTable.campaignDescription,
          peakPaymentConnectV2Month: subscriptionHistoryTable.peakPaymentConnectV2Month,
          expireDateTime: subscriptionHistoryTable.expireDateTime,
          isReceivedWht: subscriptionHistoryTable.isReceivedWht,
          whtFileName: subscriptionHistoryTable.whtFileName,
        });
      });
    }
    return { tableList: subscriptionHistoryTableDetail, rowCountAll: _subscriptionHistoryTable.rowCountAll };
  },
  ConvertToInvoiceForCreateBillingNoteTable(_transactionTableList) {
    let invoice;
    if (_transactionTableList !== null) {
      invoice = {
        pageNo: _transactionTableList.pageNo,
        pageSize: _transactionTableList.pageSize,
        transactionList: this.ConvertToInvoiceForCreateBillingNote(
          _transactionTableList.invoiceForCreateBillingNoteDetailRowList
        ),
        transactionCount: _transactionTableList.totalCount,
      };
    }
    return invoice;
  },
  ConvertToInvoiceForCreateBillingNote(_transactionTableRowList) {
    let invoiceList = [];
    if (_transactionTableRowList && _transactionTableRowList.length > 0) {
      _transactionTableRowList.forEach((_invoice, index) => {
        invoiceList.push({
          id: _invoice.invoiceId,
          invoiceId: _invoice.invoiceId,
          invoiceNumber: _invoice.invoiceNumber,
          invoiceDate: _invoice.invoiceDate,
          invoiceDueDate: _invoice.invoiceDueDate,
          invoiceNetAmount: _invoice.invoiceNetAmount,
          amountToPay: _invoice.amountToPay,
          whtAmount: _invoice.whtAmount,
          currencyRatio: _invoice.currencyRatio,
          fromCurrencyUid: _invoice.fromCurrencyUid,
          toCurrencyUid: _invoice.toCurrencyUid,
          creditNoteList: [],
          remainPaymentAmount: _invoice.remainPaymentAmount,
          remainCurrencyPaymentNetAmount: _invoice.remainCurrencyPaymentNetAmount,
          remainWhtPaymentNetAmount: _invoice.remainWhtPaymentNetAmount,
          isServiceOnly: _invoice.isServiceOnly,
          isNoneOrNotSpecifyWht: _invoice.isNoneOrNotSpecifyWht,
          sameProductVatType: _invoice.sameProductVatType,
          billingAmountError: false,
          check: false,
          referenceTransactionId: _invoice.invoiceId,
          billedAmount: _invoice.remainCurrencyPaymentNetAmount.FormatMoney(),
          invoiceCurrencyNetAmount: _invoice.invoiceCurrencyNetAmount,
          invoiceCurrencyZeroVatTotal: _invoice.invoiceCurrencyZeroVatTotal,
          invoiceCurrencyPreVatTotal: _invoice.invoiceCurrencyPreVatTotal,
          invoiceCurrencySubTotalForCalculateWht: _invoice.invoiceCurrencySubTotalForCalculateWht,
          invoiceCurrencyWhtTotal: _invoice.invoiceCurrencyWhtTotal,
          invoiceCurrencyExchangeRates: _invoice.invoiceCurrencyExchangeRates,
          invoiceCurrencyRatio: _invoice.invoiceCurrencyRatio,
          invoiceCurrencyVatExemptedTotal: _invoice.invoiceCurrencyVatExemptedTotal,
          invoiceCurrencyVatTotal: _invoice.invoiceCurrencyVatTotal,
          invoiceVatExemptedTotal: _invoice.invoiceVatExemptedTotal,
          invoiceZeroVatTotal: _invoice.invoiceZeroVatTotal,
          invoicePreVatTotal: _invoice.invoicePreVatTotal,
          invoiceVatTotal: _invoice.invoiceVatTotal,
          invoiceWhtTotal: _invoice.invoiceWhtTotal,
          invoiceSubTotalForCalculateWht: _invoice.invoiceSubTotalForCalculateWht,
          invoiceWithCreditNoteNetAmount: _invoice.invoiceWithCreditNoteNetAmount,
          invoiceCurrencyWithCreditNoteNetAmount: _invoice.invoiceCurrencyWithCreditNoteNetAmount,
        });
        if (_invoice.creditNoteList && _invoice.creditNoteList.length > 0) {
          _invoice.creditNoteList.forEach((creditNote) => {
            invoiceList[index].creditNoteList.push({
              id: creditNote.creditNoteId,
              isAllNoneOrNotSpecifyWht: creditNote.creditNoteIsAllNoneOrNotSpecifyWht,
              creditNoteAmount: creditNote.creditNoteAmount,
              transactionDate: new Date(creditNote.creditNoteIssueDate).GetDateFormat(),
              transactionId: creditNote.creditNoteId,
              transactionNetAmount: creditNote.creditNoteNetAmount,
              transactionNumber: creditNote.creditNoteNumber,
              whtAmount: creditNote.whtAmount,
            });
          });
        }
      });
    }
    return invoiceList;
  },
  GetSummaryTableBankStatementParams(input) {
    const params = {
      fromDate: input.fromDate,
      toDate: input.toDate,
    };
    return params;
  },
  GetPaymentBankStatementsByAccountIdParams(input) {
    const params = {
      pageNumber: input.pageNumber,
      pageSize: input.pageSize,
      isOrderDesc: input.sortType == Enums.TableSorting.DESC ? true : false,
      includeDeleted: false,
      orderBy: input.sortBy == Enums.TableSortingType.Date ? "date" : "amount",
      filterReconcile: input.filterReconcile,
    };

    if (input.searchText) {
      params.searchText = input.searchText;
    }

    if (input.fromDate !== null || input.fromDate !== undefined) {
      params.fromDate = input.fromDate;
    }

    if (input.toDate !== null || input.toDate !== undefined) {
      params.toDate = input.toDate;
    }

    if (input.fromAmount !== null || input.fromAmount !== undefined) {
      params.fromAmount = input.fromAmount;
    }

    if (input.toAmount !== null || input.toAmount !== undefined) {
      params.toAmount = input.toAmount;
    }

    if (input.availableToReconcile !== null || input.availableToReconcile !== undefined) {
      params.availableToReconcile = input.availableToReconcile;
    }

    return params;
  },
  GetJournalAccountListByBankAccountIdParams(input) {
    const params = {
      pageNumber: input.pageNumber,
      pageSize: input.pageSize,
      isOrderDesc: input.orderType == Enums.TableSorting.DESC ? true : false,
      includeDeleted: false,
      orderBy: input.orderBy == Enums.TableReconcileSortBy.Date ? "date" : "amount",
    };

    if (input.searchText) {
      params.searchText = input.searchText;
    }

    if (input.isReconciled !== null || input.isReconciled !== undefined) {
      params.isReconciled = input.isReconciled;
    }

    if (input.fromDate !== null || input.fromDate !== undefined) {
      params.fromDate = input.fromDate;
    }

    if (input.toDate !== null || input.toDate !== undefined) {
      params.toDate = input.toDate;
    }

    if (input.fromAmount !== null || input.fromAmount !== undefined) {
      params.fromAmount = input.fromAmount;
    }

    if (input.toAmount !== null || input.toAmount !== undefined) {
      params.toAmount = input.toAmount;
    }

    if (input.availableToReconcile !== null || input.availableToReconcile !== undefined) {
      params.availableToReconcile = input.availableToReconcile;
    }

    return params;
  },
  GetBankReconciledByBankAccountIdParams(input) {
    const params = {
      pageNumber: input.pageNumber,
      pageSize: input.pageSize,
      isOrderDesc: true,
    };

    return params;
  },
  GetInvoiceTableRequest(input) {
    return GetInvoiceTableRequest(input);
  },
  GetInvoiceTableAdvanceSearchRequest(input) {
    return GetInvoiceTableAdvanceSearchRequest(input);
  },
  GetInvoiceTableVeryAdvanceSearchRequest(input) {
    return GetInvoiceTableVeryAdvanceSearchRequest(input);
  },
  GetInvoiceTableCountRequest(input) {
    return GetInvoiceTableCountRequest(input);
  },
  GetInvoiceTableCountAdvanceSearchRequest(input) {
    return GetInvoiceTableCountAdvanceSearchRequest(input);
  },
  GetInvoiceTableCountVeryAdvanceSearchRequest(input) {
    return GetInvoiceTableCountVeryAdvanceSearchRequest(input);
  },
  GetExpenseTableRequest(input) {
    return this.GetInvoiceTableRequest(input);
  },
  GetExpenseTableAdvanceSearchRequest(input) {
    return this.GetInvoiceTableAdvanceSearchRequest(input);
  },
  GetExpenseTableVeryAdvanceSearchRequest(input) {
    return GetExpenseTableVeryAdvanceSearchRequest(input);
  },
  GetExpenseTableCountRequest(input) {
    return this.GetInvoiceTableCountRequest(input);
  },
  GetExpenseTableCountAdvanceSearchRequest(input) {
    return this.GetInvoiceTableCountAdvanceSearchRequest(input);
  },
  GetExpenseTableCountVeryAdvanceSearchRequest(input) {
    return GetExpenseTableCountVeryAdvanceSearchRequest(input);
  },
  GetPurchaseAssetTableRequest(input) {
    return this.GetExpenseTableRequest(input);
  },
  GetPurchaseAssetTableAdvanceSearchRequest(input) {
    return this.GetExpenseTableAdvanceSearchRequest(input);
  },
  GetPurchaseAssetTableVeryAdvanceSearchRequest(input) {
    return GetPurchaseAssetTableVeryAdvanceSearchRequest(input);
  },
  GetPurchaseAssetTableCountRequest(input) {
    return this.GetExpenseTableCountRequest(input);
  },
  GetPurchaseAssetTableCountAdvanceSearchRequest(input) {
    return this.GetExpenseTableCountAdvanceSearchRequest(input);
  },
  GetPurchaseAssetTableCountVeryAdvanceSearchRequest(input) {
    return GetPurchaseAssetTableCountVeryAdvanceSearchRequest(input);
  },
  GetInvoiceTableOutput(table) {
    return GetInvoiceTableOutput(table);
  },
  GetQuotationTableRequest(input) {
    return GetQuotationTableRequest(input);
  },
  GetQuotationTableAdvanceSearchRequest(input) {
    return GetQuotationTableAdvanceSearchRequest(input);
  },
  GetQuotationTableVeryAdvanceSearchRequest(input) {
    return GetQuotationTableVeryAdvanceSearchRequest(input);
  },
  GetQuotationTableCountRequest(input) {
    return GetQuotationTableCountRequest(input);
  },
  GetQuotationTableCountAdvanceSearchRequest(input) {
    return GetQuotationTableCountAdvanceSearchRequest(input);
  },
  GetQuotationTableCountVeryAdvanceSearchRequest(input) {
    return GetQuotationTableCountVeryAdvanceSearchRequest(input);
  },
  GetPurchaseOrderTableRequest(input) {
    return this.GetQuotationTableRequest(input);
  },
  GetPurchaseOrderTableAdvanceSearchRequest(input) {
    return GetPurchaseOrderTableAdvanceSearchRequest(input);
  },
  GetPurchaseOrderTableVeryAdvanceSearchRequest(input) {
    return GetPurchaseOrderTableVeryAdvanceSearchRequest(input);
  },
  GetPurchaseOrderTableCountRequest(input) {
    return this.GetQuotationTableCountRequest(input);
  },
  GetPurchaseOrderTableCountAdvanceSearchRequest(input) {
    return GetPurchaseOrderTableCountAdvanceSearchRequest(input);
  },
  GetPurchaseOrderTableCountVeryAdvanceSearchRequest(input) {
    return GetPurchaseOrderTableCountVeryAdvanceSearchRequest(input);
  },
  GetPurchaseOrderAssetTableRequest(input) {
    return this.GetPurchaseOrderTableRequest(input);
  },
  GetPurchaseOrderAssetTableAdvanceSearchRequest(input) {
    return this.GetPurchaseOrderTableAdvanceSearchRequest(input);
  },
  GetPurchaseOrderAssetTableVeryAdvanceSearchRequest(input) {
    return GetPurchaseOrderAssetTableVeryAdvanceSearchRequest(input);
  },
  GetPurchaseOrderAssetTableCountRequest(input) {
    return this.GetPurchaseOrderTableCountRequest(input);
  },
  GetPurchaseOrderAssetTableCountAdvanceSearchRequest(input) {
    return this.GetPurchaseOrderTableCountAdvanceSearchRequest(input);
  },
  GetPurchaseOrderAssetTableCountVeryAdvanceSearchRequest(input) {
    return GetPurchaseOrderAssetTableCountVeryAdvanceSearchRequest(input);
  },
  GetQuotationTableOutput(table) {
    return GetQuotationTableOutput(table);
  },
  GetReceiptTableRequest(input) {
    return GetReceiptTableRequest(input);
  },
  GetReceiptTableAdvanceSearchRequest(input) {
    return GetReceiptTableAdvanceSearchRequest(input);
  },
  GetReceiptTableVeryAdvanceSearchRequest(input) {
    return GetReceiptTableVeryAdvanceSearchRequest(input);
  },
  GetReceiptTableCountRequest(input) {
    return GetReceiptTableCountRequest(input);
  },
  GetReceiptTableCountAdvanceSearchRequest(input) {
    return GetReceiptTableCountAdvanceSearchRequest(input);
  },
  GetReceiptTableCountVeryAdvanceSearchRequest(input) {
    return GetReceiptTableCountVeryAdvanceSearchRequest(input);
  },
  GetReceiptTableOutput(table) {
    return GetReceiptTableOutput(table);
  },
  GetTaxInvoiceTableRequest(input) {
    return GetTaxInvoiceTableRequest(input);
  },
  GetTaxInvoiceTableAdvanceSearchRequest(input) {
    return GetTaxInvoiceTableAdvanceSearchRequest(input);
  },
  GetTaxInvoiceTableVeryAdvanceSearchRequest(input) {
    return GetTaxInvoiceTableVeryAdvanceSearchRequest(input);
  },
  GetTaxInvoiceTableCountRequest(input) {
    return GetTaxInvoiceTableCountRequest(input);
  },
  GetTaxInvoiceTableCountAdvanceSearchRequest(input) {
    return GetTaxInvoiceTableCountAdvanceSearchRequest(input);
  },
  GetTaxInvoiceTableCountVeryAdvanceSearchRequest(input) {
    return GetTaxInvoiceTableCountVeryAdvanceSearchRequest(input);
  },
  GetPurchaseTaxInvoiceTableRequest(input) {
    return this.GetTaxInvoiceTableRequest(input);
  },
  GetPurchaseTaxInvoiceTableAdvanceSearchRequest(input) {
    return this.GetTaxInvoiceTableAdvanceSearchRequest(input);
  },
  GetPurchaseTaxInvoiceTableVeryAdvanceSearchRequest(input) {
    return this.GetTaxInvoiceTableVeryAdvanceSearchRequest(input);
  },
  GetPurchaseTaxInvoiceTableCountRequest(input) {
    return this.GetTaxInvoiceTableCountRequest(input);
  },
  GetPurchaseTaxInvoiceTableCountAdvanceSearchRequest(input) {
    return this.GetTaxInvoiceTableCountAdvanceSearchRequest(input);
  },
  GetPurchaseTaxInvoiceTableCountVeryAdvanceSearchRequest(input) {
    return this.GetTaxInvoiceTableCountVeryAdvanceSearchRequest(input);
  },
  GetTaxInvoiceTableOutput(table) {
    return GetTaxInvoiceTableOutput(table);
  },
  GetCreditNoteTableRequest(input) {
    return GetCreditNoteTableRequest(input);
  },
  GetCreditNoteTableAdvanceSearchRequest(input) {
    return GetCreditNoteTableAdvanceSearchRequest(input);
  },
  GetCreditNoteTableVeryAdvanceSearchRequest(input) {
    return GetCreditNoteTableVeryAdvanceSearchRequest(input);
  },
  GetCreditNoteTableCountRequest(input) {
    return GetCreditNoteTableCountRequest(input);
  },
  GetCreditNoteTableCountAdvanceSearchRequest(input) {
    return GetCreditNoteTableCountAdvanceSearchRequest(input);
  },
  GetCreditNoteTableCountVeryAdvanceSearchRequest(input) {
    return GetCreditNoteTableCountVeryAdvanceSearchRequest(input);
  },
  GetReceivedCreditNoteTableRequest(input) {
    return this.GetCreditNoteTableRequest(input);
  },
  GetReceivedCreditNoteTableAdvanceSearchRequest(input) {
    return this.GetCreditNoteTableAdvanceSearchRequest(input);
  },
  GetReceivedCreditNoteTableVeryAdvanceSearchRequest(input) {
    return GetReceivedCreditNoteTableVeryAdvanceSearchRequest(input);
  },
  GetReceivedCreditNoteTableCountRequest(input) {
    return this.GetCreditNoteTableCountRequest(input);
  },
  GetReceivedCreditNoteTableCountAdvanceSearchRequest(input) {
    return this.GetCreditNoteTableCountAdvanceSearchRequest(input);
  },
  GetReceivedCreditNoteTableCountVeryAdvanceSearchRequest(input) {
    return GetReceivedCreditNoteTableCountVeryAdvanceSearchRequest(input);
  },
  GetCreditNoteTableOutput(table) {
    return GetCreditNoteTableOutput(table);
  },
  GetDebitNoteTableRequest(input) {
    return GetDebitNoteTableRequest(input);
  },
  GetDebitNoteTableAdvanceSearchRequest(input) {
    return GetDebitNoteTableAdvanceSearchRequest(input);
  },
  GetDebitNoteTableVeryAdvanceSearchRequest(input) {
    return GetDebitNoteTableVeryAdvanceSearchRequest(input);
  },
  GetDebitNoteTableCountRequest(input) {
    return GetDebitNoteTableCountRequest(input);
  },
  GetDebitNoteTableCountAdvanceSearchRequest(input) {
    return GetDebitNoteTableCountAdvanceSearchRequest(input);
  },
  GetDebitNoteTableCountVeryAdvanceSearchRequest(input) {
    return GetDebitNoteTableCountVeryAdvanceSearchRequest(input);
  },
  GetReceivedDebitNoteTableRequest(input) {
    return this.GetDebitNoteTableRequest(input);
  },
  GetReceivedDebitNoteTableAdvanceSearchRequest(input) {
    return this.GetDebitNoteTableAdvanceSearchRequest(input);
  },
  GetReceivedDebitNoteTableVeryAdvanceSearchRequest(input) {
    return GetReceivedDebitNoteTableVeryAdvanceSearchRequest(input);
  },
  GetReceivedDebitNoteTableCountRequest(input) {
    return this.GetDebitNoteTableCountRequest(input);
  },
  GetReceivedDebitNoteTableCountAdvanceSearchRequest(input) {
    return this.GetDebitNoteTableCountAdvanceSearchRequest(input);
  },
  GetReceivedDebitNoteTableCountVeryAdvanceSearchRequest(input) {
    return GetReceivedDebitNoteTableCountVeryAdvanceSearchRequest(input);
  },
  GetDebitNoteTableOutput(table) {
    return GetDebitNoteTableOutput(table);
  },
  GetBillingNoteTableRequest(input) {
    return GetBillingNoteTableRequest(input);
  },
  GetBillingNoteTableAdvanceSearchRequest(input) {
    return GetBillingNoteTableAdvanceSearchRequest(input);
  },
  GetBillingNoteTableVeryAdvanceSearchRequest(input) {
    return GetBillingNoteTableVeryAdvanceSearchRequest(input);
  },
  GetBillingNoteTableCountRequest(input) {
    return GetBillingNoteTableCountRequest(input);
  },
  GetBillingNoteTableCountAdvanceSearchRequest(input) {
    return GetBillingNoteTableCountAdvanceSearchRequest(input);
  },
  GetBillingNoteTableCountVeryAdvanceSearchRequest(input) {
    return GetBillingNoteTableCountVeryAdvanceSearchRequest(input);
  },
  GetCombinePaymentNoteTableRequest(input) {
    return this.GetBillingNoteTableRequest(input);
  },
  GetCombinePaymentNoteTableAdvanceSearchRequest(input) {
    return this.GetBillingNoteTableAdvanceSearchRequest(input);
  },
  GetCombinePaymentNoteTableVeryAdvanceSearchRequest(input) {
    return this.GetBillingNoteTableVeryAdvanceSearchRequest(input);
  },
  GetCombinePaymentNoteTableCountRequest(input) {
    return this.GetBillingNoteTableCountRequest(input);
  },
  GetCombinePaymentNoteTableCountAdvanceSearchRequest(input) {
    return this.GetBillingNoteTableCountAdvanceSearchRequest(input);
  },
  GetCombinePaymentNoteTableCountVeryAdvanceSearchRequest(input) {
    return this.GetBillingNoteTableCountVeryAdvanceSearchRequest(input);
  },
  GetBillingNoteTableOutput(table) {
    return GetBillingNoteTableOutput(table);
  },
  GetQuotationReferenceInvoiceListOutput(_quotationReferenceInvoiceList) {
    return GetQuotationReferenceInvoiceListOutput(_quotationReferenceInvoiceList);
  },
  GetStockActivityTableRequest(input) {
    return GetStockActivityTableRequest(input);
  },
  GetStockActivityTableCountRequest(input) {
    return GetStockActivityTableCountRequest(input);
  },
  GetStockActivityTableOutput(tableList, isShowRemain) {
    return GetStockActivityTableOutput(tableList, isShowRemain);
  },
  //
  GetJournalTableRequest(input) {
    return GetJournalTableRequest(input);
  },
  GetJournalTableAdvanceSearchRequest(input) {
    return GetJournalTableAdvanceSearchRequest(input);
  },
  GetJournalTableVeryAdvanceSearchRequest(input) {
    return GetJournalTableVeryAdvanceSearchRequest(input);
  },
  GetJournalTableCountRequest(input) {
    return GetJournalTableCountRequest(input);
  },
  GetJournalTableCountAdvanceSearchRequest(input) {
    return GetJournalTableCountAdvanceSearchRequest(input);
  },
  GetJournalTableCountVeryAdvanceSearchRequest(input) {
    return GetJournalTableCountVeryAdvanceSearchRequest(input);
  },
  GetJournalTableOutput(table) {
    return GetJournalTableOutput(table);
  },
  GetLotTableOutput(lot) {
    return GetLotTableOutput(lot);
  },
};
